var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.interactive ? 'button' : 'span', {
    tag: "component",
    staticClass: "alarm-level-badge",
    class: [`alarm-level-badge--${_vm.variant}`, {
      'alarm-level-badge--active': _vm.active,
      'alarm-level-badge--interactive': _vm.interactive
    }],
    attrs: {
      "type": _vm.interactive ? 'button' : undefined
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._v(" " + _vm._s(_vm.label) + " ")]);

}
var staticRenderFns = []

export { render, staticRenderFns }